import moment from "moment";

export const getNewMessage = ( refid: string, ): string => `
THIS MESSAGE MUST BE SIGNED TO ACCEPT YOUR REFERRAL.

URI:
https://bracket.fi/

Referral ID:
${refid}

Issued At:
${moment().format()}
`;
